export default {"src":"/_next/static/media/pause.b4ffb144.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};